
export default {
  props: {
    isUpgrade: {
      type: Boolean,
      default: false
    },
    removedServices: {
      type: Array,
      default: () => ([])
    }
  }
}
